var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/emoji-button-wrapper.tsx";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import "core-js/modules/web.dom-collections.iterator.js";
import classNames from 'clsx';
import React, { useState, useEffect, useRef } from 'react';
import { usePopper } from 'react-popper';
import { useDispatch } from 'react-redux';
import { simpleEmojiReact } from 'soapbox/actions/emoji-reacts';
import { openModal } from 'soapbox/actions/modals';
import EmojiSelector from 'soapbox/components/ui/emoji-selector/emoji-selector';
import { useAppSelector, useOwnAccount, useSoapboxConfig } from 'soapbox/hooks';
import { isUserTouching } from 'soapbox/is-mobile';
import { getReactForStatus } from 'soapbox/utils/emoji-reacts';

/** Provides emoji reaction functionality to the underlying button component */
const EmojiButtonWrapper = _ref => {
  let {
    statusId,
    children
  } = _ref;
  const dispatch = useDispatch();
  const ownAccount = useOwnAccount();
  const status = useAppSelector(state => state.statuses.get(statusId));
  const soapboxConfig = useSoapboxConfig();
  const timeout = useRef();
  const [visible, setVisible] = useState(false); // const [focused, setFocused] = useState(false);
  // `useRef` won't trigger a re-render, while `useState` does.
  // https://popper.js.org/react-popper/v2/

  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const {
    styles,
    attributes
  } = usePopper(referenceElement, popperElement, {
    placement: 'top-start',
    modifiers: [{
      name: 'offset',
      options: {
        offset: [-10, 0]
      }
    }]
  });
  useEffect(() => {
    return () => {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
    };
  }, []);
  if (!status) return null;

  const handleMouseEnter = () => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    if (!isUserTouching()) {
      setVisible(true);
    }
  };

  const handleMouseLeave = () => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    } // Unless the user is touching, delay closing the emoji selector briefly
    // so the user can move the mouse diagonally to make a selection.


    if (isUserTouching()) {
      setVisible(false);
    } else {
      timeout.current = setTimeout(() => {
        setVisible(false);
      }, 500);
    }
  };

  const handleReact = emoji => {
    if (ownAccount) {
      dispatch(simpleEmojiReact(status, emoji));
    } else {
      handleUnauthorized();
    }

    setVisible(false);
  };

  const handleClick = e => {
    const meEmojiReact = getReactForStatus(status, soapboxConfig.allowedEmoji) || '👍';

    if (isUserTouching()) {
      if (ownAccount) {
        if (visible) {
          handleReact(meEmojiReact);
        } else {
          setVisible(true);
        }
      } else {
        handleUnauthorized();
      }
    } else {
      handleReact(meEmojiReact);
    }

    e.preventDefault();
    e.stopPropagation();
  };

  const handleUnauthorized = () => {
    dispatch(openModal('UNAUTHORIZED', {
      action: 'FAVOURITE',
      ap_id: status.url
    }));
  }; // const handleUnfocus: React.EventHandler<React.KeyboardEvent> = () => {
  //   setFocused(false);
  // };


  const selector = /*#__PURE__*/React.createElement("div", _extends({
    className: classNames('z-50 transition-opacity duration-100', {
      'opacity-0 pointer-events-none': !visible
    }),
    ref: setPopperElement,
    style: styles.popper
  }, attributes.popper, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 125,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(EmojiSelector, {
    emojis: soapboxConfig.allowedEmoji,
    onReact: handleReact // focused={focused}
    // onUnfocus={handleUnfocus}
    ,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 133,
      columnNumber: 7
    }
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: "relative",
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 143,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.cloneElement(children, {
    onClick: handleClick,
    ref: setReferenceElement
  }), selector);
};

export default EmojiButtonWrapper;